import { generateId } from '../../formHelpers';

export const CUSTOM_TEXT_COLUMN_PREFIX = 'customCol-';
export const CUSTOM_COLUMN_DATA_TYPES = {
  TEXT: 'text',
  DATE: 'date',
};

export const CUSTOM_COLUMN_DATA_TYPE_OPTIONS = Object.values(CUSTOM_COLUMN_DATA_TYPES)
  .map((value) => ({
    value,
    label: `${value.charAt(0).toUpperCase()}${value.slice(1)}`,
  }));

export const isCustomDateColumn = (col) => (
  col?.isCustomText && col?.customDataType === CUSTOM_COLUMN_DATA_TYPES.DATE
);

export const getNativeColumnIdentifiers = (nativeOptions = {}) => {
  const nativeColumns = new Set();
  Object.entries(nativeOptions).forEach(([key, label]) => {
    nativeColumns.add(key.toLowerCase());
    if (typeof label === 'string') {
      nativeColumns.add(label.toLowerCase());
    } else if (label?.label) {
      nativeColumns.add(label.label.toLowerCase());
    } else if (label?.title) {
      nativeColumns.add(label.title.toLowerCase());
    }
  });
  return nativeColumns;
};

export const validateCustomTextColumnName = (name, {
  nativeOptions = {},
  columns = [],
  excludeKey,
} = {}) => {
  const trimmed = name?.trim();
  if (!trimmed) return 'Column name is required';

  const normalized = trimmed.toLowerCase();
  const nativeColumns = getNativeColumnIdentifiers(nativeOptions);

  if (nativeColumns.has(normalized)) {
    return 'Column name conflicts with a native column';
  }

  const hasConflict = columns.some((col) => {
    if (excludeKey && col.key === excludeKey) return false;
    return col.name?.trim().toLowerCase() === normalized
      || col.key?.toLowerCase() === normalized;
  });
  if (hasConflict) return 'Column name must be unique';

  return null;
};

export const createCustomTextColumn = (name, customDataType = CUSTOM_COLUMN_DATA_TYPES.TEXT) => ({
  key: `${CUSTOM_TEXT_COLUMN_PREFIX}${generateId()}`,
  name: name.trim(),
  isCustomText: true, // Used to determine if the column is a custom column (even though it says text)
  customDataType,
  isNumeric: false,
  isCurrency: false,
  isHideInPDF: false,
  ...(customDataType === CUSTOM_COLUMN_DATA_TYPES.DATE ? { dateLinkType: 'none' } : {}),
});
